import { IModalApplicationsPromoFilter } from "./types"

import { Button, Container, Divider, Drawer, Empty, Flex, Toogle, ToolTip } from "@ui/index"

import imgEmty from '@img/empty.svg'
import { IconClearClose } from "@img/icons"

import css from './ui.module.scss'


/** Фильтр - Заявки */
export const ModalApplicationsPromoFilter = ({ 
    isOpen, 
    filterApplicationStatuses,
    filterIsArchiveListOnly, 
    handleButtonCancel, handleApplyClearFilter
}: IModalApplicationsPromoFilter) => {

    /** Выбор статусов в окне фильтров */
    const handleSelectStatus = (id: number) => {
        const updatedStatuses = filterApplicationStatuses.value.map(status => {
            if (status.id === id) {
                return { ...status, isSelected: !status.isSelected }
            }

            return status // Возвращаем неизмененный элемент для остальных элементов массива
        })

        filterApplicationStatuses.setValue(updatedStatuses)
    }
    /** Убираем все галочки с выбранных статусов в окне фильтров */
    const handleClearSelection = () => {
        const updatedStatuses = filterApplicationStatuses.value.map(status => ({ ...status, isSelected: false }))
        filterApplicationStatuses.setValue(updatedStatuses)
    }


    return <>
        <Drawer isOpen={isOpen} zIndex={1001} isEsc isWrapper isWrapperBlur={false} onCancel={handleButtonCancel} maxWidth='370px' placement='right'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <h4>Фильтр...</h4>

                    <Button id='tooltipBtnClose' variant='icon' size='xs' onClick={handleButtonCancel}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Flex gap='4px' className='drawer_container-body'>
                    <Flex gap='20px' className='drawer_container-content'>
                        <Flex gap="4px">
                            <Divider prefix='Архив' gap="6px"
                                suffix={(filterIsArchiveListOnly.value) && 
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={() => { filterIsArchiveListOnly.reset() }}>
                                            <IconClearClose width='16px' height='16px' />
                                        </Button>
                                    </ToolTip>
                                } 
                            />

                            <Flex gap="4px">
                                <Container padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                    <p>Показать только архив:</p>

                                    <Toogle
                                        checked={filterIsArchiveListOnly.value === '1' ? true : false}
                                        onChange={(e) => {
                                            filterIsArchiveListOnly.setValue('')
                                            filterIsArchiveListOnly.setValue(e.target.checked ? '1' : '0')
                                        }} 
                                    />
                                </Container>
                            </Flex>
                        </Flex>
                        
                        <Flex gap="4px">
                            <Divider prefix='Показать только выбранные статусы' gap="6px" suffix={
                                filterApplicationStatuses.value.filter((item) => item.isSelected === true).length > 0 && 
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={handleClearSelection}>
                                            <IconClearClose width='16px' height='16px' />
                                        </Button>
                                    </ToolTip>
                                } 
                            />

                            <Flex gap="4px">
                                {filterApplicationStatuses.value.length === 0
                                    ? <Empty image={imgEmty} title="Данные отсутствуют" size='100px' /> 
                                    : filterApplicationStatuses.value.map((item) => {
                                        return (
                                            <Container key={item.id} padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                                <p>{item.name}:</p>
                                                <Toogle checked={item.isSelected} onChange={() => handleSelectStatus(item.id)} />
                                            </Container>
                                        )
                                    })
                                }
                            </Flex>
                        </Flex>
                    </Flex>

                    <div style={{gap: '5px', display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                        <Button variant="primaryDark" onClick={() => handleApplyClearFilter('clear')}>Очистить</Button>
                        <Button onClick={() => handleApplyClearFilter('apply')}>Применить</Button>
                    </div>
                </Flex>
            </Flex>
        </Drawer>
    </>
}